import { render, staticRenderFns } from "./LinkSection.vue?vue&type=template&id=0ac4c274&scoped=true&"
import script from "./LinkSection.vue?vue&type=script&lang=js&"
export * from "./LinkSection.vue?vue&type=script&lang=js&"
import style0 from "./LinkSection.vue?vue&type=style&index=0&id=0ac4c274&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ac4c274",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VMenu } from 'vuetify/lib/components/VMenu';
installComponents(component, {VDataTable,VIcon,VMenu})
